import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import parseQueryString from 'utils/queryString/parseQueryString';

/**
 * useVivaPnr hook.
 * Provides the viva_pnr query parameter from the current URL.
 * Used to determine if Viaja Ahorrando discount is active.
 *
 * @returns {string|null} The viva_pnr value or null if not present
 */
const useVivaPnr = () => {
  const location = useLocation();

  const vivaPnr = useMemo(() => {
    const queryParams = parseQueryString(location.search);
    return queryParams.viva_pnr || null;
  }, [location.search]);

  return vivaPnr;
};

export default useVivaPnr;
